<template>
	<div class="c-region" :warn="!!provinceName && warnState">
		<div class="flex">
			<c-select v-if="level >= 1" v-model="valueData.province" ref="province" class="flex-grow" :options="provinceOptions" placeholder="_t.region.province" search :disabled="disabled" @change="changeHandle($event, 'province')"></c-select>
			<c-select v-if="level >= 2" v-model="valueData.city" ref="city" class="flex-grow" :options="cityOptions" placeholder="_t.region.city" search :disabled="disabled" @change="changeHandle($event, 'city')"></c-select>
			<c-select v-if="level >= 3" v-model="valueData.county" ref="county" class="flex-grow" :options="countyOptions" placeholder="_t.region.county" search :disabled="disabled" @change="changeHandle($event, 'county')"></c-select>
		</div>
		<c-input v-if="level == 4" v-model="valueData.address" placeholder="_t.region.address" :disabled="disabled" @change="changeHandle($event, 'address')"></c-input>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library'

	export default {
		name: 'cRegion',
		
		props: {
			value: {
				type: Object,
				default: () => {
					return null;
				}
			},
			provinceName: [String, Number],  // 省份字段名
			cityName: [String, Number],  // 城市字段名
			countyName: [String, Number],  // 区县字段名
			addressName: [String, Number],  // 详细街道字段名
			level: {  // 级别（1：到省；2：到市；3：到区县；4：到详细街道地址）
				type: [Number, String],
				default: 3
			},
			disabled: Boolean,
			immediate: {
				type: Boolean,
				default: true
			}
		},

		data() {
			return {
				...getStore(this, 'cFormItemStore'),
				valueData: {
					province: '',
					city: '',
					county: '',
					address: ''
				},
				provinceOptions: [],
				cityOptions: [],
				countyOptions: []
			}
		},

		computed: {
			...mapStore('cFormItemStore', ['warnState'])
		},

		watch: {
			value(val) {
				val && this.set(val);
			}
		},

		async mounted() {
			this.immediate && await this.updateOptions('province');
			this.value && this.set(this.value);
		},

		methods: {
			async set(val = {}) {
				this.valueData.province = val.province;
				await this.updateOptions('city', val.province, val.city);
				await this.updateOptions('county', val.city, val.county);
				this.valueData.address = val.address || '';
				this.cFormItemStore && this.cFormItemStore.commit('warnState', false);
			},
			
			get() {
				return this.valueData;
			},
			
			getData() {
				return {
					province: this.$refs.province.getData(),
					city: this.$refs.city && this.$refs.city.getData(),
					county: this.$refs.county && this.$refs.county.getData(),
					address: this.valueData.address
				}
			},

			async resetOptions(data) {
				this.cityOptions = [];
				this.countyOptions = [];
				await this.updateOptions('province', data);
				this.set(this.valueData);
			},
			
			updateOptions(type, parent, val) {
				return new Promise(async resolve => {
					if (
						type == 'province' ||
						(type == 'city' && this.level > 1) ||
						(type == 'county' && this.level > 2)
					) {
						this[`${type}Options`] = [];
						if (parent || type == 'province') {
							this[`${type}Options`] = await new Promise(resolve => {
								let parentData;
								if (type != 'province') {
									parentData = this[`${type == 'county' ? 'city' : 'province'}Options`].find(item => item.value == parent) || {value: parent};
								} else {
									parentData = parent;
								}
								this.$compsConfig.data.region(type, parentData, resolve);
							});
						}
						
						if (type != 'province') {
							this.valueData[type] = val;
						}
						
						if (this.level == 1 || this.level == 2 && type == 'city' || this.level == 3 && type == 'county') {
							this.$emit('input', this.get());
						}
					}
					resolve();
				});
			},
			
			changeHandle(data, type) {
				if (type == 'province') {
					this.updateOptions('city', data.value);
					this.updateOptions('county');
				} else if (type == 'city') {
					this.updateOptions('county', data.value);
				} else {
					this.$emit('input', this.get());
				}
				this.$emit('change', this.get());
			}
		}
	} 
</script>

<style lang="stylus" scoped>
	.c-region {
		width: 100%;
		
		>>> .c-select {
			&:nth-child(n+2) {
				margin-left: 10px;
			}
		}
		
		>>> .c-input {
			margin-top: 10px;
		}

		&[warn] {
			>>> .c-select,
			>>> .c-input {
				border-color: var(--unit-warn) !important;
			}
		}
	}
</style>
